module.exports = __webpack_public_path__ + "static/img/dyinlive.0df50609.jpg";